import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import InfoGeneric from './InfoGeneric';
import InfoEventDetails from './InfoEventDetails';

const renderEventInfo = (
    currentPage,
    selectedEvent,
    widgetTitle = 'Guarantee an affordable spot by selecting an event below.',
    widgetSubtitle = null
) => {
    if (currentPage === 'map') {
        const {
            title,
            starts
        } = selectedEvent;

        return <InfoEventDetails title={title} starts={starts} />;
    }

    return <InfoGeneric title={widgetTitle} subtitle={widgetSubtitle} />;
};

const Header = ({
    searchType,
    currentPage,
    title,
    subtitle,
    selectedEvent
}) => {
    const isEvent = (searchType === 'event');

    if (!isEvent && ((!title && !subtitle))) {
        return null;
    }

    return (
        <div className="SH-Header">
            <div className="SH-Header-info">
                {(isEvent)
                    ? renderEventInfo(currentPage, selectedEvent, title, subtitle)
                    : <InfoGeneric title={title} subtitle={subtitle} />
                }
            </div>
        </div>
    );
};

Header.propTypes = {
    searchType: PropTypes.string.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    currentPage: PropTypes.string.isRequired,
    selectedEvent: PropTypes.object
};

const mapStateToProps = state => {
    const {
        search: {
            data: {
                searchType,
                currentPage,
                selectedEvent
            }
        }
    } = state;

    return {
        searchType,
        currentPage,
        selectedEvent
    };
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./widget/src/js/components/header/Header.jsx